import React from 'react'
import DetailDrawer from 'pages/Settings/components/shared/DetailDrawer'

const STATUS_TAG = {
  Completed: 'bg-success bg-opacity-10 text-success',
  Pending: 'bg-orange-500 bg-opacity-10 text-orange-500',
  Failed: 'bg-danger bg-opacity-10 text-danger'
}

function Field({ label, value }) {
  return (
    <div className="w-1/2 py-2">
      <p className="text-xs font-semibold text-secondary">{label}</p>
      <p className="text-base text-dark-blue">{value}</p>
    </div>
  )
}

function formatAmount(amount) {
  const isCredit = amount >= 0
  return `${isCredit ? '+' : '-'}GHS ${Math.abs(amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
}

export default function TransactionDetailDrawer({ transaction, onClose }) {
  return (
    <DetailDrawer title="Transaction details" onClose={onClose}>
      <div className="flex items-start justify-between gap-4 pt-4">
        <div>
          <p className="text-xs font-semibold text-secondary">{transaction.account}</p>
          <p className="text-base text-dark-blue">{transaction.type}</p>
        </div>
        <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${STATUS_TAG[transaction.status] || STATUS_TAG.Completed}`}>
          {transaction.status}
        </span>
      </div>

      <p className="text-2xl font-semibold text-dark-blue py-4">{formatAmount(transaction.amount)}</p>

      <div className="border-t border-border-lines py-4">
        <p className="text-base text-dark-blue mb-2">TRANSACTION INFORMATION</p>
        <div className="flex flex-wrap">
          <Field label="Reference ID" value={transaction.reference} />
          <Field label="Date & Time" value={transaction.dateTime} />
          <Field label="Transaction Type" value={transaction.type} />
          <Field label="Account" value={transaction.account} />
          <Field label="Description" value={transaction.description} />
        </div>
      </div>

      <div className="border-t border-border-lines py-4">
        <p className="text-base text-dark-blue mb-2">AMOUNT & BALANCE</p>
        <div className="flex flex-wrap">
          <Field label="Transaction Amount" value={formatAmount(transaction.amount)} />
          <Field label="Balance Before" value={transaction.balanceBefore} />
          <Field label="Balance After" value={transaction.balanceAfter} />
        </div>
      </div>
    </DetailDrawer>
  )
}
